import React from 'react';
import { BsTwitter, BsInstagram } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';


const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href='https://www.facebook.com/profile.php?id=100008195346922'>
        <FaFacebookF />
      </a>
    </div>
    <div>
      <a href=''>
        <BsTwitter />
      </a>
    </div>
    <div>
      <a href=''>
        <BsInstagram />
      </a>
    </div>
  </div>
);

export default SocialMedia;
